import type { ColDef } from 'ag-grid-community';
import { dateCalculation } from 'Core-utils/helpers/helpers';
import { DefaultTextCellRenderer } from '../AgGridBase';
import type { Employee } from './usersTable';
import UsersNameCellRenderer from './UsersNameCellRenderer';
import UsersScoreCellRenderer from './UsersScoreCellRenderer';
import UsersTopRiskContributorsCellRenderer from './UsersTopRiskContributorsCellRenderer';

export type UsersGridFilterOptions = {
  departmentValues: string[];
  organizationValues: string[];
  titleValues: string[];
};

export function getUsersGridColumns(options: UsersGridFilterOptions): ColDef<Employee>[] {
  const { departmentValues, organizationValues, titleValues } = options;

  return [
    {
      colId: 'score',
      field: 'score',
      headerName: 'User Score',
      sortable: true,
      filter: false,
      floatingFilter: false,
      maxWidth: 156,
      cellRenderer: UsersScoreCellRenderer,
    },
    {
      colId: 'firstName',
      headerName: 'Name',
      sortable: true,
      filter: false,
      floatingFilter: false,
      minWidth: 200,
      flex: 1,
      cellRenderer: UsersNameCellRenderer,
    },
    {
      colId: 'topRiskContributors',
      field: 'topRiskContributors',
      headerName: 'Top Risk Contributors',
      sortable: false,
      filter: false,
      floatingFilter: false,
      minWidth: 200,
      flex: 1,
      cellRenderer: UsersTopRiskContributorsCellRenderer,
    },
    {
      colId: 'department',
      field: 'department',
      headerName: 'Department',
      sortable: true,
      filter: 'agSetColumnFilter',
      floatingFilter: false,
      filterParams: {
        values: departmentValues,
      },
      minWidth: 160,
      flex: 1,
      cellRenderer: DefaultTextCellRenderer,
      cellRendererParams: {
        className: 'text-truncate',
        emptyLabel: '-',
      },
    },
    {
      colId: 'title',
      field: 'title',
      headerName: 'Title',
      sortable: true,
      filter: 'agSetColumnFilter',
      floatingFilter: false,
      filterParams: {
        values: titleValues,
      },
      minWidth: 140,
      flex: 1,
      cellRenderer: DefaultTextCellRenderer,
      cellRendererParams: {
        emptyLabel: '-',
      },
    },
    {
      colId: 'startDate',
      field: 'tenure',
      headerName: 'Tenure',
      sortable: true,
      filter: false,
      floatingFilter: false,
      maxWidth: 140,
      valueGetter: (p) => p.data?.tenure,
      cellRenderer: DefaultTextCellRenderer,
      cellRendererParams: {
        emptyLabel: '-',
        formatValue: (value: unknown) =>
          value instanceof Date ? dateCalculation(value, new Date(), 'short') : '-',
      },
    },
    {
      colId: 'organization',
      field: 'organization',
      headerName: 'Organization',
      sortable: true,
      filter: 'agSetColumnFilter',
      floatingFilter: false,
      filterParams: {
        values: organizationValues,
      },
      minWidth: 140,
      flex: 1,
      cellRenderer: DefaultTextCellRenderer,
      cellRendererParams: {
        emptyLabel: '-',
      },
    },
  ];
}
